import { create } from 'zustand';
import { Moment } from 'moment/moment';

import { ESortOrder, EStatusStr } from '@src/emp-3.0/types';
import { createSetState, removeInvalidSelectedList } from '@src/emp-3.0/utils/management';
import { IFrontendGeneratedFields } from '@src/emp-3.0/components/Management';
import { IFlowVersion } from '@src/emp-3.0/domain/flow/types';

interface IFlowMetric extends IFlowVersion, IFrontendGeneratedFields {}

interface IUseFlowsManagementStoreProps {
  openBulkAction: boolean;
  setOpenBulkAction: (openBulkAction: boolean) => void;
  totalCount: number;
  setTotalCount: (totalCount: number) => void;
  // multiple selection operation
  selectedList: IFlowMetric[];
  setSelectedList: (selectedList: IFlowMetric[]) => void;
  setRemoveInvalidSelectedList: (allSelectedList: IFlowMetric[]) => void;
  // search
  searchText: string;
  setSearchText: (searchText: string) => void;
  // sort
  sort: { key: string; order: number };
  setSort: (sort: { key: string; order: number }) => void;
  // filter condition
  showFilter: boolean;
  setShowFilter: (showFilter: boolean) => void;
  status: EStatusStr;
  setStatus: (status: EStatusStr) => void;
  updateDate: Moment[];
  setUpdateDate: (updateDate: Moment[]) => void;
  deployDate: Moment[];
  setDeployDate: (deployDate: Moment[]) => void;
  createdBy: string;
  setCreatedBy: (createdBy: string) => void;
  updatedBy: string;
  setUpdatedBy: (updatedBy: string) => void;
  // reset
  resetFilter: () => void;
  resetStore: () => void;
}

export const useFlowsManagementStore = create<IUseFlowsManagementStoreProps>((set) => ({
  totalCount: 0,
  openBulkAction: false,

  setTotalCount: createSetState(set, 'totalCount'),
  setOpenBulkAction: createSetState(set, 'openBulkAction'),

  // multiple selection operation
  selectedList: [],
  setSelectedList: createSetState(set, 'selectedList'),
  setRemoveInvalidSelectedList: removeInvalidSelectedList(set),

  // search
  searchText: '',
  setSearchText: createSetState(set, 'searchText'),

  // sort
  sort: { key: '', order: ESortOrder.NORMAL },
  setSort: createSetState(set, 'sort'),

  // filter condition
  showFilter: false,
  status: EStatusStr.ALL,
  updateDate: [],
  deployDate: [],
  createdBy: 'All',
  updatedBy: 'All',

  setShowFilter: createSetState(set, 'showFilter'),
  setStatus: createSetState(set, 'status'),
  setUpdateDate: createSetState(set, 'updateDate'),
  setDeployDate: createSetState(set, 'deployDate'),
  setCreatedBy: createSetState(set, 'createdBy'),
  setUpdatedBy: createSetState(set, 'updatedBy'),

  // reset
  resetFilter: () =>
    set(() => ({
      status: EStatusStr.ALL,
      updateDate: [],
      deployDate: [],
      createdBy: 'All',
      updatedBy: 'All',
    })),

  resetStore: () =>
    set(() => ({
      totalCount: 0,
      selectedList: [],
      searchText: '',
      showFilter: false,
      status: EStatusStr.ALL,
      updateDate: [],
      deployDate: [],
      createdBy: 'All',
      updatedBy: 'All',
      sort: { key: '', order: ESortOrder.NORMAL },
    })),
}));
